export default __webpack_public_path__ + "static/media/FA1.8e6646c3.jpg";